import {
  LegalClientEntity,
  LegalClientFirstHeadEntity,
  LegalClientLegalHeadEntity,
} from 'api/types/entity';
import { parseFullName } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

export const useFirstHeadPageTitle = (
  legalClient: LegalClientEntity | null,
  legalClientLegalHead: LegalClientLegalHeadEntity | null,
  legalClientFirstHead: LegalClientFirstHeadEntity | null
) => {
  const { t } = useTranslation();

  let fullName = legalClientFirstHead
    ? t('client.legal.legalClientFirstHead.title', {
        name: parseFullName(legalClientFirstHead),
      })
    : '';

  fullName +=
    fullName && legalClientLegalHead
      ? ` - ${legalClientLegalHead.fullName}`
      : '';

  fullName += fullName && legalClient ? ` - ${legalClient.fullName}` : '';

  usePageTitle(fullName);
};
